import { Cart } from 'src/types/cart'
// @ts-ignore
import RegistryDiscountDisplay from 'cart/components/store-order-summary/components/registry-discount-display'
import { RegistryDiscount } from 'src/types/registryDiscount'
import { PromoMessage } from 'baby-design'
import css from './FullSummary.styles.scss'
import { DiscountItem } from '../DiscountItem/DiscountItem'

export const FullSummary = ({
  checkoutTotals,
  isEligibleForRegistryDiscount,
  eligibleForMultiuseDiscount,
}: Cart & RegistryDiscount) => {
  const estimatedShippingValue =
    parseFloat(checkoutTotals.shipping) === 0 ? (
      <strong>FREE</strong>
    ) : (
      `${checkoutTotals.shipping}`
    )

  const hasShopSaleDiscount = parseFloat(checkoutTotals.saleTotalAmountOff) > 0

  const hasDiscounts =
    hasShopSaleDiscount ||
    parseFloat(checkoutTotals.registryDiscount) > 0 ||
    parseFloat(checkoutTotals.userCredit) > 0 ||
    isEligibleForRegistryDiscount

  return (
    <>
      <div className={css.FullSummary__title}>Order summary</div>
      <div className={css.FullSummary__item}>
        <span>Subtotal</span>
        <span data-testid="subtotal">
          $
          {hasShopSaleDiscount
            ? checkoutTotals.subtotalBeforeSales
            : checkoutTotals.subtotal}
        </span>
      </div>
      <div className={css.FullSummary__item}>
        <span>Estimated tax</span>
        <span>${checkoutTotals.tax}</span>
      </div>
      <div className={css.FullSummary__item}>
        <span>Estimated shipping*</span>
        <span>{estimatedShippingValue}</span>
      </div>
      {hasDiscounts && (
        <>
          <div>
            {parseFloat(checkoutTotals.userCredit) > 0 && (
              <DiscountItem
                amount={checkoutTotals.userCredit}
                label="Babylist Shop credit"
              />
            )}
            {parseFloat(checkoutTotals.saleTotalAmountOff) > 0 && (
              <DiscountItem
                amount={checkoutTotals.saleTotalAmountOff}
                label="Babylist Shop sale discount"
              />
            )}
            {isEligibleForRegistryDiscount && (
              <RegistryDiscountDisplay
                amount={parseFloat(checkoutTotals.registryDiscount)}
                className="man pan pvs xsmall"
                eligibleForMultiuseDiscount={eligibleForMultiuseDiscount}
              />
            )}
            <PromoMessage
              className="pvs"
              text="Apply promo codes in checkout"
              variant="secondary"
            />
          </div>
        </>
      )}
      <div
        className={`${css.FullSummary__item} ${css['FullSummary__item--total']}`}
      >
        <span>Total</span>
        <span>${checkoutTotals.total}</span>
      </div>
    </>
  )
}
